import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { catalogApi } from '@/lib/api';
import { ProductGrid } from '@/components/ProductGrid';

export function Category() {
  const { category = '' } = useParams<{ category: string }>();
  const list = useQuery({
    queryKey: ['catalog', 'category', category],
    queryFn: async () => (await catalogApi.list({ category, limit: 60 })).data,
  });
  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl">{category}</h1>
      <ProductGrid products={list.data} loading={list.isLoading} emptyMessage="No products in this category yet." />
    </div>
  );
}
